import vmClient from 'app/services/vmClient';
import { Issue, IIssue } from 'app/constants/schemas/Issue';
import { Sound, ISound } from 'app/constants/schemas/Sound';
import { Image, IImage } from 'app/constants/schemas/Image';
import { WordForm, IWordForm } from 'app/constants/schemas/WordForm';
import { WordTranslation, IWordTranslation } from 'app/constants/schemas/WordTranslation';
import { DictionaryTag, DictionaryTagMarshaller } from 'app/constants/enums/DictionaryTag';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { PartOfSpeech, PartOfSpeechMarshaller } from 'app/constants/enums/PartOfSpeech';

export interface ILocalWord extends IEntity {
  attributes: {
    id: EntityStringId;
    word: string;
    transliteration: string | null;
    pronunciations: string[];
    definition: string | null;
    partOfSpeech: PartOfSpeech | null;
    dictionaryTags: DictionaryTag[];
    contentLevel: number | null,
  };
  associations: {
    sound: ISound | null;
    image: IImage | null;
    translations: IWordTranslation[];
    wordForms: IWordForm[];
    issues: IIssue[];
  };
}

export type LocalWord = Entity<ILocalWord>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocalWord: IEntityType<ILocalWord> = vmClient.defineClass({
  typeName: 'LocalWord',
  version: 2,
  persisted: true,
  lockable: true,
  attributes: {
    word: {
      type: 'string',
      notNull: true,
    },
    transliteration: 'string',
    pronunciations: {
      type: 'string',
      collection: true,
      notNull: true,
    },
    definition: 'string',
    partOfSpeech: {
      type: PartOfSpeech,
      marshaller: PartOfSpeechMarshaller,
    },
    dictionaryTags: {
      type: DictionaryTag,
      marshaller: DictionaryTagMarshaller,
      collection: true,
      notNull: true,
    },
    contentLevel: 'number',
  },
  associations: {
    sound: Sound,
    image: Image,
    translations: {
      type: WordTranslation,
      collection: true,
      notNull: true,
    },
    wordForms: {
      type: WordForm,
      collection: true,
      notNull: true,
    },
    issues: {
      type: Issue,
      collection: true,
      notNull: true,
    },
  },
});
